import { supabase } from "../../../supabaseClient.jsx";

const ACTIVE_STATUSES = new Set(["authorized", "active", "approved"]);

function isActiveStatus(status) {
  return ACTIVE_STATUSES.has(String(status || "").trim().toLowerCase());
}

async function fetchByUserId(userId) {
  if (!userId) return [];

  const { data, error } = await supabase
    .from("assinaturas")
    .select("id, status, proximo_pagamento, atualizado_em, criado_em")
    .eq("usuario_id", userId)
    .order("atualizado_em", { ascending: false })
    .limit(20);

  if (error) return [];
  return data || [];
}

async function fetchByEmail(email) {
  if (!email) return [];

  const { data, error } = await supabase
    .from("assinaturas")
    .select("id, status, proximo_pagamento, atualizado_em, criado_em")
    .ilike("email", String(email).trim().toLowerCase())
    .order("atualizado_em", { ascending: false })
    .limit(20);

  if (error) return [];
  return data || [];
}

export async function getActiveSubscription({ userId, email } = {}) {
  const byUser = await fetchByUserId(userId);
  const fromUser = byUser.find((row) => isActiveStatus(row.status));
  if (fromUser) return fromUser;

  if (!email) return null;

  const byEmail = await fetchByEmail(email);
  return byEmail.find((row) => isActiveStatus(row.status)) || null;
}

export async function hasActiveSubscription(ctx = {}) {
  const assinatura = await getActiveSubscription(ctx);
  return Boolean(assinatura);
}
